import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-component-line-clamp',
  template: `
    <div #box class="boxed" [ngStyle]="boxStyles">
      <ng-content></ng-content>
    </div>
    <a
      *ngIf="enabled"
      href="javascript:void(0)"
      (click)="toggle()"
      class="small"
    >
      {{ opened ? ('MISC.SHOWLESS' | translate) : ('MISC.LEARNMORE' | translate) }}
    </a>
  `,
  styleUrls: ['./component-line-clamp.component.scss']
})
export class ComponentLineClampComponent implements AfterContentInit {
  @ContentChild('content', { static: true }) content!: ElementRef;
  @ViewChild('box', { static: true }) box!: ElementRef;

  @Input() row = 1;

  enabled = false;
  opened = false;
  boxHeight = 0;
  boxStyles: { [key: string]: any } = {
    visibility: 'hidden',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: '',
    height: ''
  };

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    requestAnimationFrame(() => {
      const contentEl = this.content.nativeElement as HTMLElement;
      const contentHeight = contentEl.scrollHeight;
      const lineHeight = getLineHeight(contentEl);
      this.boxHeight = lineHeight * this.row;

      if (contentHeight > this.boxHeight) {
        this.enable();
      }

      // Make box visible after calculation
      this.boxStyles.visibility = 'visible';
      this.cd.detectChanges();
    });
  }

  toggle(): void {
    this.opened = !this.opened;
    this.updateBoxStyles();
  }

  private enable(): void {
    this.enabled = true;
    this.opened = false;
    this.updateBoxStyles();
  }

  private updateBoxStyles(): void {
    if (this.opened) {
      this.boxStyles.WebkitLineClamp = 'initial';
      this.boxStyles.height = 'auto';
    } else {
      this.boxStyles.WebkitLineClamp = this.row.toString();
      this.boxStyles.height = `${this.boxHeight}px`;
    }
  }
}

function getLineHeight(element: HTMLElement): number {
  const computed = window.getComputedStyle(element);
  let lineHeight = parseFloat(computed.lineHeight);

  if (isNaN(lineHeight)) {
    const clone = element.cloneNode(true) as HTMLElement;
    clone.innerHTML = '<br>';
    clone.style.display = 'block';
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    element.appendChild(clone);
    lineHeight = clone.clientHeight;
    element.removeChild(clone);
  }

  return lineHeight;
}
